import { render, staticRenderFns } from "./SwiperArticles.vue?vue&type=template&id=0d649a36&"
import script from "./SwiperArticles.vue?vue&type=script&lang=js&"
export * from "./SwiperArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports